/* eslint-disable @typescript-eslint/camelcase */
import { handleActions } from 'redux-actions';
import {
  ActivateReportProps,
  BlockMultipleSessionReportProps,
  ClientsState,
  ConnectionTypeReportProps,
  MFAReportProps,
  SaltReportProps,
  UseProfileReportProps,
  VirtualizerReportProps,
} from './interfaces';
import Types from './types';

const initialState: ClientsState = {
  isLoading: false,
  clientSelected: null,
  testConnection: null,
  isConnecting: false,
  urlConnectionRemoteApp: '',
  urlChromeExtension: '',
  clientList: {
    count: 0,
    next: '',
    previous: '',
    results: [],
  },
  clientsList: {
    count: 0,
    next: '',
    previous: '',
    results: [],
  },
  listSessionClients: {
    count: 0,
    next: '',
    previous: '',
    results: [],
  },
  clientUsers: {
    count: 0,
    next: '',
    previous: '',
    results: [],
  },
  listApplications: {
    count: 0,
    next: '',
    previous: '',
    results: [],
  },
  listAvailableApplications: {
    count: 0,
    next: '',
    previous: '',
    loading: false,
    results: [],
  },
  historySessions: {
    count: 0,
    next: '',
    previous: '',
    loading: false,
    results: [],
  },
  clientsMaintenanceDisplayWarning: {
    active: false,
    start_date: '',
    end_date: '',
    message: '',
    display_to_logged_users: false,
  },
  accessControl: {
    loading: false,
    settings: {
      control_by_schedule: false,
      control_by_ip: false,
    },
    allowedIps: {
      count: 0,
      next: '',
      previous: '',
      results: [],
    },
    blockedPeriods: {
      count: 0,
      next: '',
      previous: '',
      results: [],
    },
  },
  isLoadingUsers: false,
  connectionTypeReport: {} as ConnectionTypeReportProps,
  isLoadingConnectionTypeReport: false,
  blockMultipleSessionReport: {} as BlockMultipleSessionReportProps,
  isLoadingBlockMultipleSessionReport: false,
  useProfileReport: {} as UseProfileReportProps,
  isLoadingUseProfileReport: false,
  MFAReport: {} as MFAReportProps,
  isLoadingMFAReport: false,
  virtualizerReport: {} as VirtualizerReportProps,
  isLoadingVirtualizerReport: false,
  activateReport: {} as ActivateReportProps,
  isLoadingActivateReport: false,
  saltReport: {} as SaltReportProps,
  isLoadingSaltReport: false,
};

export default handleActions(
  {
    [Types.GET_ALL_CLIENTS_REQUEST]: (state: ClientsState) => ({
      ...state,
      isLoading: true,
    }),
    [Types.GET_ALL_CLIENTS_FULFILLED]: (state: ClientsState, { payload }) => ({
      ...state,
      clientList: payload,
      isLoading: false,
    }),
    [Types.GET_ALL_CLIENTS_REJECTED]: (state: ClientsState) => ({
      ...state,
      isLoading: false,
    }),

    [Types.GET_ALL_CLIENTS_OPERATOR_REQUEST]: (state: ClientsState) => ({
      ...state,
      isLoading: true,
    }),
    [Types.GET_ALL_CLIENTS_OPERATOR_FULFILLED]: (
      state: ClientsState,
      { payload }
    ) => ({
      ...state,
      clientsList: payload,
      isLoading: false,
    }),
    [Types.GET_ALL_CLIENTS_OPERATOR_REJECTED]: (state: ClientsState) => ({
      ...state,
      isLoading: false,
    }),

    [Types.CREATE_USER_IN_CLIENTE_REQUEST]: (state: ClientsState) => ({
      ...state,
      isLoading: true,
    }),
    [Types.CREATE_USER_IN_CLIENTE_FULFILLED]: (state: ClientsState) => ({
      ...state,
      isLoading: false,
    }),
    [Types.CREATE_USER_IN_CLIENTE_REJECTED]: (state: ClientsState) => ({
      ...state,
      isLoading: false,
    }),

    [Types.SAVE_URL_CONNECTION_REQUEST]: (state: ClientsState) => ({
      ...state,
    }),
    [Types.SAVE_URL_CONNECTION_FULFILLED]: (
      state: ClientsState,
      { payload }
    ) => ({
      ...state,
      urlConnectionRemoteApp: payload,
    }),

    [Types.SAVE_CHROME_EXTENSION_REQUEST]: (state: ClientsState) => ({
      ...state,
    }),
    [Types.SAVE_CHROME_EXTENSION_FULFILLED]: (
      state: ClientsState,
      { payload }
    ) => ({
      ...state,
      urlChromeExtension: payload,
    }),

    [Types.GET_HISTORY_SESSIONS_REQUEST]: (state: ClientsState) => ({
      ...state,
      isLoading: true,
    }),
    [Types.GET_HISTORY_SESSIONS_FULFILLED]: (
      state: ClientsState,
      { payload }
    ) => ({
      ...state,
      historySessions: payload,
      isLoading: false,
    }),
    [Types.GET_HISTORY_SESSIONS_REJECTED]: (state: ClientsState) => ({
      ...state,
      isLoading: false,
    }),

    [Types.ACTIVE_MFA_TO_ALL_USER_REQUEST]: (state: ClientsState) => ({
      ...state,
      isLoading: true,
    }),
    [Types.ACTIVE_MFA_TO_ALL_USER_FULFILLED]: (
      state: ClientsState,
      { payload }
    ) => ({
      ...state,
      clientSelected: {
        ...state.clientSelected,
        user_mfa_is_active: payload,
      },
      isLoading: false,
    }),
    [Types.ACTIVE_MFA_TO_ALL_USER_REJECTED]: (state: ClientsState) => ({
      ...state,
      isLoading: false,
    }),

    [Types.NEW_CLIENT_REQUEST]: (state: ClientsState) => ({
      ...state,
      isLoading: true,
    }),
    [Types.NEW_CLIENT_FULFILLED]: (state: ClientsState) => ({
      ...state,
      isLoading: false,
    }),
    [Types.NEW_CLIENT_REJECTED]: (state: ClientsState) => ({
      ...state,
      isLoading: false,
    }),

    [Types.EDIT_CLIENT_REQUEST]: (state: ClientsState) => ({
      ...state,
      isLoading: true,
    }),
    [Types.EDIT_CLIENT_FULFILLED]: (state: ClientsState) => ({
      ...state,
      isLoading: false,
    }),
    [Types.EDIT_CLIENT_REJECTED]: (state: ClientsState) => ({
      ...state,
      isLoading: false,
    }),

    [Types.NEW_CLONE_CLIENT_REQUEST]: (state: ClientsState) => ({
      ...state,
      isLoading: true,
    }),
    [Types.NEW_CLONE_CLIENT_FULFILLED]: (state: ClientsState) => ({
      ...state,
      isLoading: false,
    }),
    [Types.NEW_CLONE_CLIENT_REJECTED]: (state: ClientsState) => ({
      ...state,
      isLoading: false,
    }),

    [Types.REMOVE_CLIENT_REQUEST]: (state: ClientsState) => ({
      ...state,
      isLoading: true,
    }),
    [Types.REMOVE_CLIENT_FULFILLED]: (state: ClientsState) => ({
      ...state,
      isLoading: false,
    }),
    [Types.REMOVE_CLIENT_REJECTED]: (state: ClientsState) => ({
      ...state,
      isLoading: false,
    }),

    [Types.NEW_APPLICATION_REQUEST]: (state: ClientsState) => ({
      ...state,
      isLoading: true,
    }),
    [Types.NEW_APPLICATION_FULFILLED]: (state: ClientsState) => ({
      ...state,
      isLoading: false,
    }),
    [Types.NEW_APPLICATION_REJECTED]: (state: ClientsState) => ({
      ...state,
      isLoading: false,
    }),

    [Types.EDIT_APPLICATION_REQUEST]: (state: ClientsState) => ({
      ...state,
      isLoading: true,
    }),
    [Types.EDIT_APPLICATION_FULFILLED]: (state: ClientsState) => ({
      ...state,
      isLoading: false,
    }),
    [Types.EDIT_APPLICATION_REJECTED]: (state: ClientsState) => ({
      ...state,
      isLoading: false,
    }),

    [Types.GET_APPLICATIONS_REQUEST]: (state: ClientsState) => ({
      ...state,
      isLoading: true,
    }),
    [Types.GET_APPLICATIONS_FULFILLED]: (state: ClientsState, { payload }) => ({
      ...state,
      listApplications: payload,
      isLoading: false,
    }),
    [Types.GET_APPLICATIONS_REJECTED]: (state: ClientsState) => ({
      ...state,
      isLoading: false,
    }),

    [Types.GET_AVAILABLE_APPLICATIONS_REQUEST]: (state: ClientsState) => ({
      ...state,
      listAvailableApplications: {
        ...state.listAvailableApplications,
        loading: true,
      },
    }),
    [Types.GET_AVAILABLE_APPLICATIONS_FULFILLED]: (
      state: ClientsState,
      { payload }
    ) => ({
      ...state,
      listAvailableApplications: {
        ...payload,
        loading: false,
      },
    }),
    [Types.GET_AVAILABLE_APPLICATIONS_REJECTED]: (state: ClientsState) => ({
      ...state,
      listAvailableApplications: {
        ...state.listAvailableApplications,
        loading: false,
      },
    }),

    [Types.GET_MAINTENANCE_REQUEST]: (state: ClientsState) => ({
      ...state,
      isLoading: true,
      clientsMaintenanceDisplayWarning:
        initialState?.clientsMaintenanceDisplayWarning,
    }),
    [Types.GET_MAINTENANCE_FULFILLED]: (state: ClientsState, { payload }) => ({
      ...state,
      ...payload,
      isLoading: false,
    }),
    [Types.GET_MAINTENANCE_REJECTED]: (state: ClientsState) => ({
      ...state,
      isLoading: false,
    }),
    [Types.CLEAR_MAINTENANCE_DATA]: (state: ClientsState) => ({
      ...state,
      clientsMaintenanceDisplayWarning:
        initialState?.clientsMaintenanceDisplayWarning,
    }),

    [Types.GET_CLIENTS_BY_ID_REQUEST]: (state: ClientsState) => ({
      ...state,
      isLoading: true,
    }),
    [Types.GET_CLIENTS_BY_ID_FULFILLED]: (
      state: ClientsState,
      { payload }
    ) => ({
      ...state,
      clientSelected: payload,
      isLoading: false,
    }),
    [Types.GET_CLIENTS_BY_ID_REJECTED]: (state: ClientsState) => ({
      ...state,
      isLoading: false,
    }),

    [Types.GET_SESSIONS_CLIENTS_REQUEST]: (state: ClientsState) => ({
      ...state,
      isLoading: true,
    }),
    [Types.GET_SESSIONS_CLIENTS_FULFILLED]: (
      state: ClientsState,
      { payload }
    ) => ({
      ...state,
      listSessionClients: payload,
      isLoading: false,
    }),
    [Types.GET_SESSIONS_CLIENTS_REJECTED]: (state: ClientsState) => ({
      ...state,
      isLoading: false,
    }),

    [Types.GET_ALL_CLIENTS_USERS_REQUEST]: (state: ClientsState) => ({
      ...state,
      isLoading: true,
    }),
    [Types.GET_ALL_CLIENTS_USERS_REJECTED]: (state: ClientsState) => ({
      ...state,
      isLoading: false,
    }),
    [Types.GET_ALL_CLIENTS_USERS_FULFILLED]: (
      state: ClientsState,
      { payload }
    ) => ({
      ...state,
      clientUsers: payload,
      isLoading: false,
    }),

    [Types.REMOVE_CLIENT_USER_REQUEST]: (state: ClientsState) => ({
      ...state,
      isLoading: true,
    }),
    [Types.REMOVE_CLIENT_USER_FULFILLED]: (state: ClientsState) => ({
      ...state,
      isLoading: false,
    }),
    [Types.REMOVE_CLIENT_USER_REJECTED]: (state: ClientsState) => ({
      ...state,
      isLoading: false,
    }),

    [Types.EDIT_CLIENT_USER_REQUEST]: (state: ClientsState) => ({
      ...state,
      isLoading: true,
    }),
    [Types.EDIT_CLIENT_USER_FULFILLED]: (state: ClientsState) => ({
      ...state,
      isLoading: false,
    }),
    [Types.EDIT_CLIENT_USER_REJECTED]: (state: ClientsState) => ({
      ...state,
      isLoading: false,
    }),

    [Types.REMOVE_CLIENT_APPLICATION_REQUEST]: (state: ClientsState) => ({
      ...state,
      isLoading: true,
    }),
    [Types.REMOVE_CLIENT_APPLICATION_FULFILLED]: (state: ClientsState) => ({
      ...state,
      isLoading: false,
    }),
    [Types.REMOVE_CLIENT_APPLICATION_REJECTED]: (state: ClientsState) => ({
      ...state,
      isLoading: false,
    }),

    [Types.REMOVE_CLIENT_WEB_APPLICATION_REQUEST]: (state: ClientsState) => ({
      ...state,
      isLoading: true,
    }),
    [Types.REMOVE_CLIENT_WEB_APPLICATION_FULFILLED]: (state: ClientsState) => ({
      ...state,
      isLoading: false,
    }),
    [Types.REMOVE_CLIENT_WEB_APPLICATION_REJECTED]: (state: ClientsState) => ({
      ...state,
      isLoading: false,
    }),

    [Types.GET_ACCESS_CONTROL_REQUEST]: (state: ClientsState) => ({
      ...state,
      accessControl: {
        ...state.accessControl,
        loading: true,
      },
    }),
    [Types.GET_ACCESS_CONTROL_FULFILLED]: (
      state: ClientsState,
      { payload }
    ) => ({
      ...state,
      accessControl: {
        ...payload,
        loading: false,
      },
    }),
    [Types.GET_ACCESS_CONTROL_REJECTED]: (state: ClientsState) => ({
      ...state,
      accessControl: {
        ...state.accessControl,
        loading: false,
      },
    }),

    [Types.TEST_OPEN_APPLICATION_REQUEST]: (state: ClientsState) => ({
      ...state,
      isConnecting: true,
    }),
    [Types.TEST_OPEN_APPLICATION_FULFILLED]: (
      state: ClientsState,
      { payload }
    ) => ({
      ...state,
      isConnecting: false,
      testConnection: payload,
    }),
    [Types.TEST_OPEN_APPLICATION_REJECTED]: (state: ClientsState) => ({
      ...state,
      testConnection: null,
      isConnecting: false,
    }),

    [Types.CLEAR_TEST_OPEN_APPLICATION]: (state: ClientsState) => ({
      ...state,
      testConnection: null,
    }),

    [Types.EDIT_MAINTENANCE_REQUEST]: (state: ClientsState) => ({
      ...state,
      isLoading: true,
    }),
    [Types.EDIT_MAINTENANCE_FULFILLED]: (state: ClientsState) => ({
      ...state,
      isLoading: false,
    }),
    [Types.EDIT_MAINTENANCE_REJECTED]: (state: ClientsState) => ({
      ...state,
      isLoading: false,
    }),

    [Types.ACTIVATE_MULTIPLE_APPLICATIONS_REQUEST]: (state: ClientsState) => ({
      ...state,
      isLoading: true,
    }),
    [Types.ACTIVATE_MULTIPLE_APPLICATIONS_FULFILLED]: (
      state: ClientsState
    ) => ({
      ...state,
      isLoading: false,
    }),
    [Types.ACTIVATE_MULTIPLE_APPLICATIONS_REJECTED]: (state: ClientsState) => ({
      ...state,
      isLoading: false,
    }),

    [Types.INACTIVATE_MULTIPLE_APPLICATIONS_REQUEST]: (
      state: ClientsState
    ) => ({
      ...state,
      isLoading: true,
    }),
    [Types.INACTIVATE_MULTIPLE_APPLICATIONS_FULFILLED]: (
      state: ClientsState
    ) => ({
      ...state,
      isLoading: false,
    }),
    [Types.INACTIVATE_MULTIPLE_APPLICATIONS_REJECTED]: (
      state: ClientsState
    ) => ({
      ...state,
      isLoading: false,
    }),

    [Types.REMOVE_MULTIPLE_APPLICATIONS_REQUEST]: (state: ClientsState) => ({
      ...state,
      isLoading: true,
    }),
    [Types.REMOVE_MULTIPLE_APPLICATIONS_FULFILLED]: (state: ClientsState) => ({
      ...state,
      isLoading: false,
    }),
    [Types.REMOVE_MULTIPLE_APPLICATIONS_REJECTED]: (state: ClientsState) => ({
      ...state,
      isLoading: false,
    }),
    [Types.GET_BLOCK_MULTIPLE_SESSION_REPORT_REJECTED]: (
      state: ClientsState
    ) => ({
      ...state,
      isLoadingBlockMultipleSessionReport: false,
    }),
    [Types.GET_BLOCK_MULTIPLE_SESSION_REPORT_REQUEST]: (
      state: ClientsState
    ) => ({
      ...state,
      isLoadingBlockMultipleSessionReport: true,
    }),
    [Types.GET_BLOCK_MULTIPLE_SESSION_REPORT_FULFILLED]: (
      state: ClientsState,
      { payload }
    ) => ({
      ...state,
      isLoadingBlockMultipleSessionReport: false,
      blockMultipleSessionReport: payload,
    }),
    [Types.GET_CONNECTION_TYPE_REPORT_FULFILLED]: (
      state: ClientsState,
      { payload }
    ) => ({
      ...state,
      isLoadingConnectionTypeReport: false,
      connectionTypeReport: payload,
    }),
    [Types.GET_CONNECTION_TYPE_REPORT_REJECTED]: (state: ClientsState) => ({
      ...state,
      isLoadingConnectionTypeReport: false,
    }),
    [Types.GET_CONNECTION_TYPE_REPORT_REQUEST]: (state: ClientsState) => ({
      ...state,
      isLoadingConnectionTypeReport: true,
    }),
    [Types.GET_USE_PROFILE_REPORT_FULFILLED]: (
      state: ClientsState,
      { payload }
    ) => ({
      ...state,
      isLoadingUseProfileReport: false,
      useProfileReport: payload,
    }),
    [Types.GET_USE_PROFILE_REPORT_REJECTED]: (state: ClientsState) => ({
      ...state,
      isLoadingUseProfileReport: false,
    }),
    [Types.GET_USE_PROFILE_REPORT_REQUEST]: (state: ClientsState) => ({
      ...state,
      isLoadingUseProfileReport: true,
    }),
    [Types.GET_MFA_REPORT_FULFILLED]: (state: ClientsState, { payload }) => ({
      ...state,
      isLoadingMFAReport: false,
      MFAReport: payload,
    }),
    [Types.GET_MFA_REPORT_REJECTED]: (state: ClientsState) => ({
      ...state,
      isLoadingMFAReport: false,
    }),
    [Types.GET_MFA_REPORT_REQUEST]: (state: ClientsState) => ({
      ...state,
      isLoadingMFAReport: true,
    }),
    [Types.GET_CLIENT_VIRTUALIZER_REPORT_FULFILLED]: (
      state: ClientsState,
      { payload }
    ) => ({
      ...state,
      isLoadingVirtualizerReport: false,
      virtualizerReport: payload,
    }),
    [Types.GET_CLIENT_VIRTUALIZER_REPORT_REJECTED]: (state: ClientsState) => ({
      ...state,
      isLoadingVirtualizerReport: false,
    }),
    [Types.GET_CLIENT_VIRTUALIZER_REPORT_REQUEST]: (state: ClientsState) => ({
      ...state,
      isLoadingVirtualizerReport: true,
    }),

    [Types.GET_ACTIVATE_REPORT_FULFILLED]: (
      state: ClientsState,
      { payload }
    ) => ({
      ...state,
      isLoadingActivateReport: false,
      activateReport: payload,
    }),
    [Types.GET_ACTIVATE_REPORT_REJECTED]: (state: ClientsState) => ({
      ...state,
      isLoadingActivateReport: false,
    }),
    [Types.GET_ACTIVATE_REPORT_REQUEST]: (state: ClientsState) => ({
      ...state,
      isLoadingActivateReport: true,
    }),
    [Types.GET_SALT_REPORT_FULFILLED]: (state: ClientsState, { payload }) => ({
      ...state,
      isLoadingSaltReport: false,
      saltReport: payload,
    }),
    [Types.GET_SALT_REPORT_REJECTED]: (state: ClientsState) => ({
      ...state,
      isLoadingSaltReport: false,
    }),
    [Types.GET_SALT_REPORT_REQUEST]: (state: ClientsState) => ({
      ...state,
      isLoadingSaltReport: true,
    }),

    [Types.EXPORT_CLIENT_SUMMARY_REQUEST]: (state: ClientsState) => ({
      ...state,
      isLoading: true,
    }),
    [Types.EXPORT_CLIENT_SUMMARY_FULFILLED]: (state: ClientsState) => ({
      ...state,
      isLoading: false,
    }),
    [Types.EXPORT_CLIENT_SUMMARY_REJECTED]: (state: ClientsState) => ({
      ...state,
      isLoading: false,
    }),

    [Types.EXPORT_USER_SUMMARY_REQUEST]: (state: ClientsState) => ({
      ...state,
      isLoadingUsers: true,
    }),
    [Types.EXPORT_USER_SUMMARY_FULFILLED]: (state: ClientsState) => ({
      ...state,
      isLoadingUsers: false,
    }),
    [Types.EXPORT_USER_SUMMARY_REJECTED]: (state: ClientsState) => ({
      ...state,
      isLoadingUsers: false,
    }),

    [Types.ENABLE_USER_DEVICE_VALIDATION_BYPASS_REQUEST]: (
      state: ClientsState
    ) => ({
      ...state,
      isLoadingUsers: true,
    }),
    [Types.ENABLE_USER_DEVICE_VALIDATION_BYPASS_FULFILLED]: (
      state: ClientsState
    ) => ({
      ...state,
      isLoadingUsers: false,
    }),
    [Types.ENABLE_USER_DEVICE_VALIDATION_BYPASS_REJECTED]: (
      state: ClientsState
    ) => ({
      ...state,
      isLoadingUsers: false,
    }),

    [Types.DISABLE_USER_DEVICE_VALIDATION_BYPASS_REQUEST]: (
      state: ClientsState
    ) => ({
      ...state,
      isLoadingUsers: true,
    }),
    [Types.DISABLE_USER_DEVICE_VALIDATION_BYPASS_FULFILLED]: (
      state: ClientsState
    ) => ({
      ...state,
      isLoadingUsers: false,
    }),
    [Types.DISABLE_USER_DEVICE_VALIDATION_BYPASS_REJECTED]: (
      state: ClientsState
    ) => ({
      ...state,
      isLoadingUsers: false,
    }),
  },
  initialState
);
